export default __webpack_public_path__ + "static/media/aribaGrayTransparent.0d55e19a.png";